/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'same2': {
    width: 16,
    height: 16,
    viewBox: '0 0 22.76 22.76',
    data: '<defs/><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><circle pid="0" class="cls-1" cx="11.38" cy="11.38" r="10.88"/><circle pid="1" class="cls-2" cx="7.44" cy="9.3" r="1.64"/><circle pid="2" class="cls-2" cx="16.16" cy="9.3" r="1.64"/><path pid="3" class="cls-3" d="M5.8 14.8h12"/></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/icons/same2.js